import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import ZoomControlContainer from './ZoomControlContainer'
import ButtonPastDatetime from '../components/ButtonPastDatetime'
import ButtonFutureDatetime from '../components/ButtonFutureDatetime'
import ButtonFutureYear from '../components/ButtonFutureYear'
import ButtonPastYear from '../components/ButtonPastYear'
import StyleToggle from '../components/StyleToggle'
import DriftPlaceholder from '../components/DriftPlaceholder'
import LoginButton from '../components/LoginButton'
import LogoutButton from '../components/LogoutButton'
import LoginActions from '../redux/loginRedux'
// import SliderDatetimeMain from '../components/SliderDatetimeMain'
import SliderDatetimeMain from '../components/SliderDatetimeVertical'
import { PRODUCTION } from '../config/constants'
import { withErrorBoundary } from '../errors/ErrorBoundary'

const styles = theme => ({
  account: {
    marginTop: 20
  },
  drawerPaper: {
    backgroundColor: 'rgba(255, 255, 255, 0)',
    border: 0,
    overflow: 'visible',
    zIndex: 100,
    boxShadow: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  slider: {
    flex: 'auto',
    border: 0,
    marginTop: 0
  },
  navigation: {
    flex: 'auto'
  }
})

class RightNavigation extends PureComponent {
  render () {
    const { actions, authenticated, classes, roles, hideDatetimeSlider } = this.props

    return (
      <Drawer
        open={true}
        anchor='right'
        variant='permanent'
        classes={{ paper: classes.drawerPaper }}
      >
        {!authenticated && (
          <LoginButton
            className={classes.account}
            onClick={actions.loginRequested}
          />
        )}
        {!!authenticated && (
          <LogoutButton
            className={classes.account}
            onClick={actions.logout}
            username={roles.name || ''}
          />
        )}
      <ZoomControlContainer />
        <div data-tour='time-navigation' style={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        {false && <ButtonFutureYear />}
        <div data-tour='time-forward' style={{}}>
        <ButtonFutureDatetime hidden={hideDatetimeSlider} />
        </div>
          <div data-tour='time-slider' style={{height: '100%', display: 'flex'}}>
        <SliderDatetimeMain  vertical={true} hidden={hideDatetimeSlider} />
        </div>
        <div data-tour='time-backward' style={{}}>
        <ButtonPastDatetime hidden={hideDatetimeSlider} />
        </div>
        {false && <ButtonPastYear />}
        </div>
        <StyleToggle />
        <DriftPlaceholder />
      </Drawer>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticated: state.login.authenticated,
    roles: state.login.roles,
    hideDatetimeSlider: state.service.serviceCardActive.hideDatetimeSlider
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      loginRequested: () => dispatch(LoginActions.loginRequested()),
      logout: () => {
        dispatch(LoginActions.logout())
      }
    }
  }
}

export default withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(RightNavigation)
))



// WEBPACK FOOTER //
// ./src/containers/RightNavigation.js